import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sp-add-appfolio-credential',
  templateUrl: './add-appfolio-credential.component.html',
  styleUrls: ['./add-appfolio-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddAppFolioCredentialComponent {
  @Input() formGroup: FormGroup;
}
